import { Card } from "@shopify/polaris";
import React from "react";
import { Col, Row } from "reactstrap";
import bottombanner from "../../../assets/affiliate/bottombanner.png";
import callApi from "../../../utils/apiCaller";
import Arrow from "./svgs/Arrow";

const BottomBanner = () => {
	const handleClickMode = (note) => {
		let params = {
			action: "clickReview",
			type: "click_affiliate_bottom",
			note: note,
		};
		callApi("get", params).then(async (res) => {});
	};
	return (
		<div className="st-affiliate-bottom-banner">
			<Card>
				<Row>
					<Col md={6}>
						<div>
							<img src={bottombanner} />
						</div>
					</Col>
					<Col md={6}>
						<div>
							<span>Ready to make money?</span>
							<div>
								<a
									href="https://platform.shoffi.app/signup/affiliate?app=Il_VwAn8snq"
									target="_blank"
								>
									<button
										className="affiliate-button-primary"
										onClick={() =>
											handleClickMode("btn_join_now")
										}
									>
										Join now
										<Arrow />
									</button>
								</a>
								<a
									href="https://synctrack.gitbook.io/affiliate/faqs"
									target="_blank"
								>
									<button className="affiliate-button-third">
										Read our FAQs
										<Arrow />
									</button>
								</a>
							</div>
						</div>
					</Col>
				</Row>
			</Card>
		</div>
	);
};

export default BottomBanner;
